import { useEffect } from 'react'
import { Icon } from '@iconify/react'
import {
  CAMPAIGN_SALES_WINNER_AWAIT_MESSAGE,
  CAMPAIGN_SALES_WINNER_AWAIT_TITLE,
} from '@/lib/campaign-sales'
import styles from './LandingSalesClosedModal.module.css'

type LandingSalesClosedModalProps = {
  open: boolean
  onClose: () => void
}

export function LandingSalesClosedModal({ open, onClose }: LandingSalesClosedModalProps) {
  useEffect(() => {
    if (!open) return

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.card}
        role="dialog"
        aria-modal="true"
        aria-labelledby="landing-sales-closed-title"
        aria-describedby="landing-sales-closed-message"
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar aviso">
          <Icon icon="mdi:close" width={20} height={20} />
        </button>
        <div className={styles.stamp}>Encerrado</div>
        <div className={styles.seal} aria-hidden>
          <Icon icon="mdi:trophy-outline" />
        </div>
        <h2 id="landing-sales-closed-title" className={styles.title}>
          {CAMPAIGN_SALES_WINNER_AWAIT_TITLE}
        </h2>
        <p id="landing-sales-closed-message" className={styles.message}>
          {CAMPAIGN_SALES_WINNER_AWAIT_MESSAGE}
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.confirm} onClick={onClose}>
            Entendi
          </button>
        </div>
      </div>
    </div>
  )
}
